import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private socket!: WebSocket;
  private dataSubject = new Subject<string>();
  private reconnectAttempts = 0;
  private maxReconnectAttempts = 5;
  private readonly WS_URL = 'wss://bullionprice.logimaxindia.com:3004/socket.io/?EIO=3&transport=websocket';

  constructor() { }

  connect(): void {
    try {
      // Close existing socket if any
      if (this.socket) {
        this.socket.close();
      }

      this.socket = new WebSocket(this.WS_URL);

      this.socket.onopen = () => {
        console.log('WebSocket connection opened');
        this.reconnectAttempts = 0;
      };

      this.socket.onmessage = (event) => {
        // ONLY emit if data is valid and not 'undefined'
        if (event.data && 
            event.data !== 'undefined' && 
            event.data !== 'null' && 
            event.data !== '' &&
            typeof event.data === 'string') {
          this.dataSubject.next(event.data);
        }
      };

      this.socket.onclose = (event) => {
        console.log('WebSocket connection closed:', event.code, event.reason);
        this.attemptReconnect();
      };

      this.socket.onerror = (error) => {
        console.error('WebSocket error:', error);
        // Don't reconnect here, let onclose handle it
      };

    } catch (error) {
      console.error('Error creating WebSocket:', error);
      this.attemptReconnect();
    }
  }

  private attemptReconnect(): void {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts++;
      const delay = Math.min(1000 * Math.pow(2, this.reconnectAttempts), 30000);
      
      console.log(`Reconnecting WebSocket... Attempt ${this.reconnectAttempts}/${this.maxReconnectAttempts} in ${delay}ms`);
      
      setTimeout(() => {
        this.connect();
      }, delay);
    } else {
      console.error('Max reconnection attempts reached');
    }
  }

  getDataStream(): Observable<string> {
    return this.dataSubject.asObservable().pipe(
      // Filter out any invalid data at the stream level
      filter(data => data !== null && data !== undefined && data !== 'undefined')
    );
  }

  startFetching(): Observable<string> {
    this.connect();
    return this.getDataStream();
  }

  send(message: string): void {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(message);
    } else {
      console.warn('WebSocket is not open. Cannot send message.');
    }
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.close();
    }
    this.dataSubject.complete();
  }
}